import { render, staticRenderFns } from "./SidenavLink.vue?vue&type=template&id=44393b58&"
import script from "./SidenavLink.vue?vue&type=script&lang=js&"
export * from "./SidenavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../suport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports